(function(){
  if (window.__pcardMobileGallery) return;
  window.__pcardMobileGallery = true;
  document.addEventListener('scroll', function(e){
    var track = e.target;
    if (!track || !track.classList || !track.classList.contains('pcard-mgallery__track')) return;
    var width = track.clientWidth || 1;
    var index = Math.round(Math.abs(track.scrollLeft) / width);
    var dots = track.parentNode.querySelectorAll('.pcard-mgallery__dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }
  }, { capture: true, passive: true });
})();
